// 导出相关的类型定义

export interface Column {
  header: string;
  key: string;
  width?: number;
  style?: any;
}

export interface ExportData {
  total: number;
  items: any[];
}

export interface SelectionParams {
  pageSize: number;
  pageIndex: number;
  [key: string]: any;
}

export interface SelectionFunction {
  (params: SelectionParams): Promise<{ data: ExportData }>;
}

export interface ResolverFunction {
  (data: any): Record<string, any>;
}

export interface ExportModalProps {
  params?: Record<string, any>;
  title: string;
  columns: Column[];
  resolver: ResolverFunction;
  selection: SelectionFunction;
  pageSize?: number;
  showProgress?: boolean;
  buttonText?: string;
  buttonType?: 'primary' | 'secondary' | 'dashed' | 'outline' | 'text';
  buttonStatus?: 'success' | 'warning' | 'danger' | 'default';
}

// 导出状态
export interface ExportState {
  loading: boolean;
  progress: number;
  totalCount: number;
  currentCount: number;
}

// 错误类型
export interface ExportError {
  message: string;
  code?: string;
  retryCount?: number;
}

// 配置常量
export const EXPORT_CONFIG = {
  DEFAULT_PAGE_SIZE: 1000,
  MAX_RETRY_COUNT: 3,
  RETRY_DELAY: 1000,
  MAX_PAGES: 1000,
};
